import { Capacitor } from '@capacitor/core';

/**
 * Registers the PWA service worker (public/sw.js) for the web build only.
 *
 * Must never run inside the Capacitor native WebView - a service worker
 * intercepting fetches there would fight with the native app's own network
 * handling and isn't needed (there's no "install to home screen" concept to
 * support; the app already is the installed thing).
 *
 * Also skipped outside production builds so it doesn't interfere with the
 * Vite dev server / HMR.
 */
export function registerServiceWorker(): void {
  if (Capacitor.isNativePlatform()) return;
  if (!import.meta.env.PROD) return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.error('Service worker registration failed:', error);
    });
  });
}
